var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"md-layout-item md-size-100 md-small-size-100 forgot-layout",staticStyle:{"margin-bottom":"50px"}},[(_vm.isLoading)?_c('md-progress-bar',{staticClass:"md-accent",attrs:{"md-mode":"indeterminate"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }